/* ============================================================
   About the Designer — atd-
   Sets --atd-vw to the true viewport width (excluding the
   scrollbar) so 100vw full-bleed never causes horizontal
   overflow. Falls back to 100vw if JS never runs.
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = '[data-atd-root]';

  function apply() {
    var vw = document.documentElement.clientWidth;
    var roots = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < roots.length; i++) {
      roots[i].style.setProperty('--atd-vw', vw + 'px');
    }
  }

  var raf = null;
  function onResize() {
    if (raf) {
      window.cancelAnimationFrame(raf);
    }
    raf = window.requestAnimationFrame(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('orientationchange', onResize, { passive: true });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector(SELECTOR)) {
      apply();
    }
  });
})();